import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import PublicLayout from './components/layout/PublicLayout';
import AdminLayout from './admin/layouts/AdminLayout';
import Home from './pages/Home';
import Projects from './pages/Projects';
import ProjectDetail from './pages/ProjectDetail';
import Resume from './pages/Resume';
import Certifications from './pages/Certifications';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Dashboard from './admin/pages/Dashboard';
import ManageProjects from './admin/pages/ManageProjects';
import ManageSkills from './admin/pages/ManageSkills';
import ManageExperience from './admin/pages/ManageExperience';
import ManageEducation from './admin/pages/ManageEducation';
import ManageCertifications from './admin/pages/ManageCertifications';
import ManageBlogs from './admin/pages/ManageBlogs';
import ManageContacts from './admin/pages/ManageContacts';
import ManageProfile from './admin/pages/ManageProfile';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/" element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route path="projects" element={<Projects />} />
                <Route path="projects/:slug" element={<ProjectDetail />} />
                <Route path="resume" element={<Resume />} />
                <Route path="certifications" element={<Certifications />} />
                <Route path="blog" element={<Blog />} />
                <Route path="blog/:slug" element={<BlogDetail />} />
                <Route path="contact" element={<Contact />} />
              </Route>
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="projects" element={<ManageProjects />} />
                <Route path="skills" element={<ManageSkills />} />
                <Route path="experience" element={<ManageExperience />} />
                <Route path="education" element={<ManageEducation />} />
                <Route path="certifications" element={<ManageCertifications />} />
                <Route path="blogs" element={<ManageBlogs />} />
                <Route path="contacts" element={<ManageContacts />} />
                <Route path="profile" element={<ManageProfile />} />
              </Route>
            </Routes>
          </Router>
          <ToastContainer position="bottom-right" theme="colored" />
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
